<!-- App.vue (Root)  -->
<template>
  <div id="app">
    <ToastManager />
    <router-view :key="$route.params.id"></router-view>
  </div>

</template>

<script>
import ToastManager from '@/components/ToastManager.vue'
export default {
  name: 'App',
  components: {
    ToastManager
  },
  created() {
    // 捕捉 ?ref=CODE 推廣碼，存入 localStorage（7天）
    const urlParams = new URLSearchParams(window.location.search);
    const ref = urlParams.get('ref');
    if (ref) {
      const expires = Date.now() + 7 * 24 * 60 * 60 * 1000; // 7天
      localStorage.setItem('affiliateRef', JSON.stringify({ code: ref, expires }));
    }
  }
}
</script>
